import * as React from "react";
const SVGComponent = (props) => (
    <svg width={17} height={18} viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="m9.869 2.675-7.701 8.177c-.291.31-.573.922-.629 1.346l-.347 3.048c-.122 1.101.666 1.854 1.754 1.666l3.02-.518c.423-.075 1.014-.386 1.304-.706l7.701-8.176c1.332-1.412 1.933-3.02-.14-4.987-2.064-1.948-3.63-1.261-4.962.15"
            stroke="#001659"
            strokeWidth={1.07}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.584 4.04a5.77 5.77 0 0 0 1.73 3.3 5.74 5.74 0 0 0 3.382 1.546"
            stroke="#001659"
            strokeWidth={1.07}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default SVGComponent;
